import toast from 'react-hot-toast';
import { AppToast } from '../components/toast/AppToast';

/**
 * Toast de producto con iconos del centro de notificaciones.
 * Usa id estable para evitar duplicados del mismo evento.
 */
export const showAppToast = ({
    title,
    message,
    tone = 'chat',
    duration = 4500,
    id,
} = {}) => {
    const toastId = id || undefined;

    return toast.custom(
        (t) => (
            <AppToast
                visible={t.visible}
                title={title}
                message={message}
                tone={tone}
                onDismiss={() => toast.dismiss(t.id)}
            />
        ),
        {
            id: toastId,
            duration,
        },
    );
};
